import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=4728665b&scoped=true&"
import script from "./CreateList.vue?vue&type=script&lang=js&"
export * from "./CreateList.vue?vue&type=script&lang=js&"
import style0 from "./CreateList.vue?vue&type=style&index=0&id=4728665b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728665b",
  null
  
)

export default component.exports